import { Col } from "react-bootstrap";
import { useState } from 'react'; 

export const ProjectCard = ({ title, description, imgUrl }) => {
  const [isTextVisible, setIsTextVisible] = useState(true); 

  const handleClick = () => {
    setIsTextVisible(!isTextVisible); 
  };

  return (
    <Col size={12} sm={6} md={4}>
      <div 
        className={`proj-imgbx ${isTextVisible ? 'text-visible' : 'image-only'}`} 
        onClick={handleClick}
      >
        <img src={imgUrl} />
        
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  );
}
